module.exports = __webpack_public_path__ + "img/Australia.7e6bda79.svg";